/* eslint-disable import/prefer-default-export */
export const maskPhone = ({
  phone = '',
  canSeeFullPhone = true,
  visibleDigits = 7,
  maskChar = '*'
}) => {
  if (!phone || phone.length < 5) return phone;

  if (!canSeeFullPhone) {
    return (
      phone.slice(0, visibleDigits)
      + maskChar.repeat(Math.max(phone.length - visibleDigits, 0))
    );
  }

  return phone;
};
